// extracted by mini-css-extract-plugin
export default {"breakdown-value-tooltip":"components-parity-tooltips-breakdown-value-tooltip-module__breakdown-value-tooltip"};